import React from 'react';
import styled from 'styled-components';
import { Breakpoints, Color, Grid, Type } from '../../../app/StyleGuide';
import { CurriculumImage } from '../../../components/CurriculumImage';
import formatDate from '../utils/formatDate';

const SubInfoRow = styled.div`
  background: ${Color.Gray._10};
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: ${Grid._3};
  padding: ${Grid._4};
  color: ${Color.Gray._70};
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  line-height: ${Type.Leading.normal};
  align-items: start;

  span {
    font-size: ${Type.Scale._2};
    font-weight: ${Type.Weight.normal};
    color: ${Color.Gray._70};
  }

  a {
    color: ${Color.Gray._90};
    font-weight: ${Type.Weight.bold};
    display: block;
    width: 100%;
    display: flex;
    cursor: pointer;
    text-align: left;
  }

  a:hover {
    text-decoration: underline;
  }

  @media screen and (min-width: ${Breakpoints.screen_sm}) {
    grid-template-columns: ${Grid._14} minmax(0, 1fr);
    gap: 0;
    padding: ${Grid._4} ${Grid._7} ${Grid._4} 0;
  }
`;

const ChangingToLabel = styled.div`
  font-weight: ${Type.Weight.normal};

  @media screen and (min-width: ${Breakpoints.screen_sm}) {
    padding-left: ${Grid._5};
  }
`;

const CurriculumRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${Grid._3};
  min-width: 0;

  ${CurriculumImage} {
    height: 64px;
    width: 132px;

    svg {
      max-height: 50%;
    }
  }

  @media screen and (min-width: ${Breakpoints.screen_sm}) {
    flex-direction: row;
    align-items: center;

    ${CurriculumImage} {
      height: 77px;
      width: 158px;
    }
  }
`;

const CurriculumDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;

  a {
    overflow-wrap: anywhere;
  }
`;

export const UpcomingSubscriptionRow = ({
  brandCode,
  title,
  startDate,
  onClick,
}: {
  brandCode: string;
  title: string;
  startDate: string;
  onClick: () => void;
}) => {
  return (
    <SubInfoRow>
      <ChangingToLabel>Changing to:</ChangingToLabel>
      <CurriculumRow>
        <CurriculumImage brandCode={brandCode} />

        <CurriculumDetails>
          <a
            onClick={e => {
              e.stopPropagation();
              onClick();
            }}
            data-tracking-component="license-footer"
          >
            {title}
          </a>
          {startDate && <span>Begins: {formatDate(startDate)}</span>}
        </CurriculumDetails>
      </CurriculumRow>
    </SubInfoRow>
  );
};
